import {Injectable, signal, Signal, OnDestroy, inject} from '@angular/core';
import {BreakpointObserver} from '@angular/cdk/layout';
import {Subscription} from 'rxjs';

/**
 * Service exposant si l'application est affichée sur un mobile ou non.
 */
@Injectable({
	providedIn: 'root'
})
export class AdaptateurEcranService implements OnDestroy {
	// Injections
	private breakpointObserver = inject(BreakpointObserver);

	// Variables
	private _estAffichageMobile = signal<boolean>(false);
	readonly estAffichageMobile: Signal<boolean> = this._estAffichageMobile.asReadonly();

	private subscription: Subscription;

	constructor() {
		this.subscription = this.breakpointObserver
			.observe('(max-width: 700px)')
			.subscribe(result => {
				this._estAffichageMobile.set(result.matches);
			});
	}

	ngOnDestroy(): void {
		if (this.subscription) {
			this.subscription.unsubscribe();
		}
	}
}
